import { AuthService } from './auth.service';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor,
    HttpErrorResponse,
    HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { ToasterComponent } from '../../toasterComponent/toasterComponent';
import { Configuration } from '..';
import { tap } from 'rxjs/operators';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        public auth: AuthService,
        public _toaster: ToasterComponent,
        public _global: Configuration) { }

    public handelSSOLoginResponse(result) {
        if (result && result.headers) {
            const contentType: string = result.headers.get('Content-type');
            if (result.status == 200 && contentType != null
                && (contentType.includes('text') || contentType.includes('html'))) {
                window.location.href = '/epms/noAuth/sdgSSO';
            }
        }
    }

    public intercept(request: HttpRequest<any>, next: HttpHandler):Observable<HttpEvent<any>> {
        if (typeof window.localStorage.getItem('activeToken') !== 'undefined'
            && window.localStorage.getItem('activeToken') != null
            && window.localStorage.getItem('activeToken').trim() !== '') {
            request = request.clone({
                headers: request.headers.set('X-AUTH-TOKEN',
                    window.localStorage.getItem('activeToken'))
            });
        } else {
            this.clearLocalStorage();
            window.location.href = this._global.get('USER_APP_URL')+"/";
        }
        return next.handle(request).pipe(tap((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
                let auth = event.headers.get('X-Auth-Token');
                if (typeof auth !== 'undefined' && auth != null) {
                    window.localStorage.setItem('activeToken', event.headers.get('X-Auth-Token'));
                }
                if (request.url.includes('getAdminOperations')) {
                    this.handelSSOLoginResponse(event);
                }
            }
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401 || err.status === 403) {
                    this.clearLocalStorage();
                    window.location.href = this._global.get('USER_APP_URL')+"/";
                } else if (err.status === 500) {
                    this._toaster.showError('Something Went Wrong ');
                } else if (err.status === 503) {
                    this._toaster.showError('Service Unavailable');
                } else if (err.status === 200) {
                    if (request.url.includes('getAdminOperations')) {
                        this.handelSSOLoginResponse(err);
                    }
                }
            }
        }));
    }

    public clearLocalStorage() {
        window.localStorage.clear();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/jwt.interceptor.ts